import Pqp from "../../3x1010/Pqp.js";

export default class DialogNewsletter {
  constructor(form, dialog) {
    this.form = form;
    this.input = this.form?.querySelector("input[type='email']");
    this.btn = this.form?.querySelector(".js-btn-open-dialog-newsletter");
    this.dialogTemplate = dialog;
    this.dialog;
    this.timeout;
  }

  init() {
    this.initEmailForm();
  }

  initEmailForm() {
    this.btn?.addEventListener("click", (e) => {
      e.preventDefault();

      if (!Pqp.validateEmail(this.input?.value)) {
        !this.form.classList.contains("has-error")
          && this.form.classList.add("has-error");

      } else {
        const val = this.input.value;
        this.form.classList.remove("has-error");
        this.showDialog(val);

        if (this.input) {
          this.input.value = "";
        }
      }
    });
  }

  showDialog(val) {
    this.dialog = this.dialogTemplate?.cloneNode(true);    

    const inputEmail = this.dialog.querySelector(".js-email");
    if (inputEmail) {
      inputEmail.value = val;
    }

    // events
    this.dialog?.addEventListener("close", this.removeDialog.bind(this));
    this.dialog?.querySelector(".js-dialog-close")?.addEventListener("click", this.hideDialog.bind(this));

    document.body.appendChild(this.dialog);

    this.dialog?.showModal();
    this.timeout = setTimeout(() => {
      this.dialog?.classList.add("is-visible");
    }, 250);
  }

  hideDialog() {
    this.removeDialog();
  }

  removeDialog() {
    this.dialog.remove();
  }
}